<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card title="Manage Subcription Plans" v-bind:class="'custom-title-btn'">
      <div class>
        <div class="float-right md:w-auto md:mt-0 sm:w-full w-full sm:mt-3 mt-3">
          <!-- <div class="float-right inline-block">
            <vs-input
                name="search"
                placeholder="Search"
                class="w-full no-icon-border"
                v-model="search"
                @keyup.enter="getItems()"
              />
          </div>-->
          <div class="float-right add-drivers mr-2">
            <vs-button class="m-auto" color="#0057FF" @click.stop="addItem()">Add Subcription Plan</vs-button>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="mt-5 mb-5">
        <vs-table :data="plans">
          <template slot="thead">
            <vs-th sort-key="plan_name">Title</vs-th>
            <vs-th>Annually Price</vs-th>
            <vs-th>Quarterly Price</vs-th>
            <!-- <vs-th>Monthly Price</vs-th> -->
            <vs-th>Total Users</vs-th>
            <vs-th>Deactivate/Activate</vs-th>
            <vs-th class="inline-block">Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.plan_name | capitalize }}</vs-td>
              <vs-td>{{ tr.price_per_year }}</vs-td>
              <vs-td>{{ tr.price_per_quarter }}</vs-td>
              <!-- <vs-td>{{ tr.price_per_month }}</vs-td> -->
              <vs-td>{{ tr.max_users }}</vs-td>
              <vs-td>
                <vs-switch
                  v-model="tr.is_active"
                  @change="confirmDelete(indextr,tr.id,tr.is_active)"
                  v-if="!tr.is_freeplan"
                />
                <span v-else>--</span>
              </vs-td>
              <vs-td width="150px;" class="inline-block">
                <!-- <vs-button
                  color="dark"
                  type="filled"
                  class="float-left mr-2"
                  icon-pack="feather"
                  icon="icon-eye"
                  size="small"
                  title="View Application"
                  @click.stop="viewApplication(tr.id)"
                ></vs-button>-->
                <vs-button
                  color="warning"
                  type="filled"
                  class="float-left mr-2 mb-2"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  size="small"
                  title="Edit Plan"
                  @click.stop="editPlan(tr.id)"
                ></vs-button>
                <!-- <vs-button
                  color="danger"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  size="small"
                  title="Delete Plan"
                  v-show="tr.is_freeplan === false"
                  @click.stop="confirmDelete(tr.id)"
                ></vs-button>-->
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div style="height:50px;">
        <div class="float-left">
          <vs-select label="Record Per Page" v-model="perPage" autocomplete>
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in recordList"
            />
          </vs-select>
        </div>
        <div class="float-right mt-5">
          <vs-pagination ref="paginationApplication" :total="totalPage" v-model="currentPage"></vs-pagination>
        </div>
      </div>
    </vx-card>
    <!-- Popup For Delete/Change Status Rejection Reason  -->
    <vs-popup class="holamundo" title="Confirm" :active.sync="popupActive">
      <div class="vx-col vs-lg-12 float-left form-group mb-2 w-full">
        <h5 v-if="deleteStatus == true">Are you sure you want to activate this subcription plan?</h5>
        <h5 v-else>Are you sure you want to deactivate this subcription plan?</h5>
      </div>
      <div class="vx-col vs-lg-12 mt-2 float-left form-group mb-2 w-full">
        <vs-button
          color="success"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="confirmBlockUnblock()"
        >{{deleteStatus == true ? 'Activate' : 'Deactivate'}}</vs-button>
        <vs-button
          color="warning"
          type="filled"
          class="mr-2 edit-user float-left"
          @click.stop="canclepopup()"
        >Cancel</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { API_URL } from "@/axios/axios";

export default {
  components: {},
  data() {
    return {
      popupActive: false,
      deleteIndex: null,
      deleteStatus: null,
      switch1: null,
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      status: "A",
      switch1: true,
      plans: [],
      recordList: [
        {
          text: 25,
          value: 25
        },
        {
          text: 50,
          value: 50
        },
        {
          text: 100,
          value: 100
        },
        {
          text: 250,
          value: 250
        }
      ],
      search: null
    };
  },
  mounted: function() {
    this.getItems();
  },
  computed: {},
  watch: {
    popupActive(nv) {
      if (nv == false) {
        this.getItems();
      }
    },
    status(nv) {
      if (nv.length === 0) {
        this.perPage = 25;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
      }
      this.getItems();
    },
    currentPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 25;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getItems();
      }
    }
  },
  methods: {
    countUsers(n1, n2, n3, n4) {
      let count = parseInt(n1) + parseInt(n2) + parseInt(n3) + parseInt(n4);
      return count;
    },
    apiUrl() {
      // let pageNo = this.currentPage - 1;
      // let pageLimit = this.perPage;
      let url = "subcription/getAll";
      // url += "?pageNo=" + pageNo + "&pageLimit=" + pageLimit;

      // if (this.search) {
      //   url += "&search=" + this.search;
      // }
      return url;
    },
    getItems() {
      this.$vs.loading({ color: "primary" });
      let url = this.apiUrl();
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.plans = data;
          //this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch(e => {
          this.showError(e);
        });
    },
    viewApplication(index) {
      this.$router.push("/plans/view/" + index);
    },
    addItem() {
      this.$router.push({ name: "addSubcriptionPlan" });
    },
    editPlan(index) {
      this.$router.push("/admin/subcription-plan/edit/" + index);
    },
    confirmDelete(index, id, status) {
      this.deleteIndex = id;
      this.deleteStatus = status;
      this.popupActive = true;
      // if (status == true) {
      //     text = "Are you sure you want to activate this subcription plan?";
      // }
      // if (status == false)
      // {
      //     text = "Are you sure you want to deactivate this subcription plan?";
      // }

      // this.$vs.dialog({
      //   type: "confirm",
      //   color: "danger",
      //   title: `Confirm`,
      //   text: text,
      //   acceptText: "Delete",
      //   // accept: this.deleteItem,
      //   cancel: this.getItems,
      //   accept: this.confirmBlockUnblock
      // });
    },
    canclepopup() {
      this.popupActive = false;
      this.deleteIndex = null;
      this.deleteStatus = null;
      this.getItems();
    },
    confirmBlockUnblock() {
      let input = {
        id: this.deleteIndex,
        is_active: this.deleteStatus
      };
      this.$vs.loading({ color: "primary" });

      this.axios
        .put("subcription/edit", input)
        .then(response => {
          this.$vs.loading.close();

          if (!this.deleteStatus) {
            var text = "Plan has been deactivated successfully";
          } else {
            var text = "Plan has been activated successfully";
          }

          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = null;
          this.popupActive = false;
          this.deleteStatus = null;
          //this.getApplications();
        })
        .catch(e => {
          this.showError(e);
        });
    },

    deleteItem() {
      // let input = {
      //   data : {
      //     id: this.deleteIndex
      //   }
      // };
      // this.$vs.loading({ color: "primary" });
      // this.axios
      //   .delete("subcription/deleteOne", input)
      //   .then(response => {
      //     this.$vs.loading.close();
      //     let text = "Subcription plan deleted successfully";
      //     this.$vs.notify({
      //       text: text,
      //       color: "success",
      //       position: "top-right"
      //     });
      //     this.deleteIndex = 0;
      //     this.getItems();
      //   })
      //   .catch(e => {
      //     this.deleteIndex = 0;
      //     this.showError(e);
      //   });
    }
  }
};
</script>

<style>
.application-action {
  float: left !important;
}
</style>
		